var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul',[_c('restricted',{attrs:{"groups":['KaiAdmins', 'KaiEditors']}},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'conversations-list' },"exact":""}},[_vm._v("Conversations")])],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }